import { gql } from '@graphql/__generated__';

export const USER_ACTIVE_MODULE_GRANTS_FRAGMENT = gql(/* GraphQL */ `
  fragment UserActiveModuleGrants on users {
    module_grants(order_by: { module_id: asc }) {
      module_id
    }
  }
`);

export const IMPROVE_TEXT = gql(/* GraphQL */ `
  query LotImproveDescription($text: String!) {
    improve_text(text: $text) {
      text
    }
  }
`);

export const GET_PROPERTY_TYPES = gql(/* GraphQL */ `
  query getPropertyTypes {
    property_types {
      id
      name
      label
      main_type
      composite_type
      type
      composite_type_object {
        id
        label
        name
      }
    }
  }
`);

export const GET_USER_TEAMS = gql(/* GraphQL */ `
  query getUserTeams($userId: uuid!) {
    teams_users(where: { user_id: { _eq: $userId } }) {
      team_id
      user_id
    }
  }
`);

export const GET_LEAD_ASSIGN_STAGE_QUERY = gql(/* GraphQL */ `
  query GetAssignStage($pipeline_id: uuid!) {
    lead_stages(
      where: { name: { _eq: "assign" }, pipeline_id: { _eq: $pipeline_id } }
      limit: 1
    ) {
      id
    }
  }
`);

export const GET_PROPERTY_DUPLICATION_DATA = gql(/* GraphQL */ `
  query GetPropertyDuplicationData($id: uuid!) {
    leads_by_pk(id: $id) {
      id
      property {
        id
        property_images {
          id
        }
        property_files {
          file_id
          property_id
        }
      }
    }
  }
`);

export const DOC_TEMPLATE_DEFAULT_LINKS_FRAGMENT = gql(/* GraphQL */ `
  fragment DocTemplateDefaultLinks on doc_templates {
    doc_templates_tenants {
      tenant_id
      is_default
    }
    doc_templates_teams {
      team_id
      is_default
    }
  }
`);

export const GET_DOC_TEMPLATES_FOR_DEFAULT = gql(/* GraphQL */ `
  query GetDocTemplatesForDefault($types: [doc_template_type_enum_enum!]!) {
    doc_templates(limit: 100, where: { type: { _in: $types } }) {
      id
      name
      type
      active
      ...DocTemplateDefaultLinks
    }
  }
`);

export const DOC_TEMPLATE_THEMES = gql(/* GraphQL */ `
  query DocTemplateThemes($type: doc_template_type_enum_enum!) {
    doc_templates(
      order_by: { name: asc }
      where: {
        type: { _eq: $type }
        active: { _eq: true }
        content: { _neq: "" }
        theme: { active: { _eq: true } }
      }
    ) {
      id
      name
    }
  }
`);

export const GET_PHONE_NUMBERS_TYPES = gql(/* GraphQL */ `
  query GetPhoneNumbersTypes {
    phone_number_type_enum {
      value
    }
  }
`);
